export default "__VITE_ASSET__z5$jEkf0__"